import React, { memo } from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { SidebarContainer } from '@atlassian/jira-navigation-apps-sidebar-nav4-common/src/ui/sidebar-container';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-common/src/ui/skeleton';
import Placeholder from '@atlassian/jira-placeholder';

const LazyPlanSettingsSidebar = lazyAfterPaint(() =>
	import(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-plan-settings" */ './main'
	).then(({ PlanSettingsSidebar }) => PlanSettingsSidebar),
);

const AsyncSidebar = () => (
	<JSErrorBoundary
		id="asyncSidebarPlanSettings"
		packageName="jiraNavigationAppsSidebarNav4PlanSettings"
		teamName="otter"
	>
		<SidebarContainer>
			<Placeholder name="asyncSidebarPlanSettings" fallback={<Skeleton />}>
				<LazyPlanSettingsSidebar />
			</Placeholder>
		</SidebarContainer>
	</JSErrorBoundary>
);

export default memo(AsyncSidebar);
